import React, { Suspense } from "react";
import { SensorKit } from "@/sensorKits/sensorKit";
import { SensorKitAlertFilters } from "@/alerts/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { SensorKitAlertsList } from "../alerts/SensorKitAlertsList";

interface SensorKitDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  sensorKit: SensorKit | null;
  alertFilters: SensorKitAlertFilters | null;
}

export const SensorKitDialog = ({ isOpen, onOpenChange, sensorKit, alertFilters }: SensorKitDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-6xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            Alerts for {sensorKit?.serial_number}
          </DialogTitle>
        </DialogHeader>

        {sensorKit && alertFilters && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4 p-4 bg-gray-50 rounded-lg">
              <div>
                <strong>Serial Number:</strong> {sensorKit.serial_number}
              </div>
              <div>
                <strong>Model:</strong> {sensorKit.config.model.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
              </div>
              <div>
                <strong>Version:</strong> {sensorKit.config.version}
              </div>
              <div>
                <strong>Installation:</strong> {sensorKit.current_installation?.name || 'No installation'}
              </div>
            </div>

            <Suspense fallback={<div>Loading alerts...</div>}>
              <SensorKitAlertsList alertFilters={alertFilters} />
            </Suspense>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
